class CollectionParallax {
  constructor() {
    this.container = document.querySelector("[data-collection-banner]")
    this.parallaxBg = document.querySelector("[data-parallax-bg]")
    this.parallaxImage = document.querySelector("[data-parallax-image]")
    this.parallaxOverlay = document.querySelector("[data-parallax-overlay]")
    this.heroContent = document.querySelector("[data-hero-content]")
    this.scrollIndicator = document.querySelector("[data-scroll-indicator]")
    this.productGrid = document.querySelector(".main-collection-product-grid")
    this.footer = document.querySelector(".footer")

    // Early return if elements don't exist
    if (!this.container) return

    // Store initial values
    this.lastScrollY = window.pageYOffset
    this.ticking = false
    this.containerHeight = this.container.offsetHeight
    this.windowHeight = window.innerHeight

    // Initialize
    this.init()
  }

  init() {
    // Add a class to the body for CSS targeting
    document.body.classList.add("has-collection-parallax")

    // Set initial position of parallax background - COMPLETELY FIXED
    if (this.parallaxBg) {
      this.parallaxBg.style.position = "fixed"
      this.parallaxBg.style.top = "0"
      this.parallaxBg.style.left = "0"
      this.parallaxBg.style.width = "100%"
      this.parallaxBg.style.height = "100vh"
      this.parallaxBg.style.zIndex = "-1"
    }

    // Ensure the image stays completely fixed
    if (this.parallaxImage) {
      this.parallaxImage.style.position = "absolute"
      this.parallaxImage.style.top = "0"
      this.parallaxImage.style.left = "0"
      this.parallaxImage.style.width = "100%"
      this.parallaxImage.style.height = "100%"
      this.parallaxImage.style.transform = "none" // NO TRANSFORM AT ALL
    }

    // Set initial state
    this.handleScroll()

    // Bind events
    this.bindEvents()

    // Smooth scroll when clicking scroll indicator
    if (this.scrollIndicator) {
      this.scrollIndicator.addEventListener("click", () => {
        const scrollTarget = this.containerHeight * 0.8
        window.scrollTo({
          top: scrollTarget,
          behavior: "smooth",
        })
      })
    }

    // Ensure product grid has proper z-index and styling
    if (this.productGrid) {
      this.productGrid.style.position = "relative"
      this.productGrid.style.zIndex = "2"
      this.productGrid.style.background = "transparent"
    }

    // Ensure footer has proper z-index
    if (this.footer) {
      this.footer.style.position = "relative"
      this.footer.style.zIndex = "3"
      this.footer.style.background = "#f8f8f8"
    }
  }

  bindEvents() {
    window.addEventListener("scroll", () => this.onScroll(), { passive: true })
    window.addEventListener("resize", () => this.onResize(), { passive: true })

    // Handle page load state
    if (document.readyState === "complete") {
      this.onResize()
    } else {
      window.addEventListener("load", () => this.onResize())
    }
  }

  onScroll() {
    this.lastScrollY = window.pageYOffset

    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.handleScroll()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  onResize() {
    // Update dimensions on resize
    this.containerHeight = this.container.offsetHeight
    this.windowHeight = window.innerHeight

    this.handleScroll()
  }

  handleScroll() {
    const scrollY = this.lastScrollY
    const containerHeight = this.containerHeight

    // Calculate scroll progress (0 to 1)
    const scrollProgress = Math.min(scrollY / (containerHeight * 0.8), 1)

    // ONLY CHANGE OPACITY - NO MOVEMENT AT ALL
    if (this.parallaxBg) {
      let opacity

      if (scrollProgress < 0.3) {
        // Full opacity in hero section
        opacity = 1
      } else if (scrollProgress < 0.7) {
        // Gradual fade as we scroll into product grid
        opacity = Math.max(0.2, 1 - (scrollProgress - 0.3) * 2)
      } else {
        // Maintain minimum opacity in product grid area
        opacity = 0.2 // Keep background visible but subtle
      }

      // KEEP BACKGROUND COMPLETELY FIXED - ONLY CHANGE OPACITY
      this.parallaxBg.style.opacity = opacity.toString()
      // DO NOT CHANGE POSITION OR TRANSFORM
    }

    // ENSURE IMAGE NEVER MOVES
    if (this.parallaxImage) {
      this.parallaxImage.style.transform = "none" // Force no transform
    }

    // Content fade and move (only for hero content)
    if (this.heroContent) {
      const contentOpacity = Math.max(1 - scrollProgress * 2, 0)
      const contentY = scrollProgress * 50
      this.heroContent.style.opacity = contentOpacity.toString()
      this.heroContent.style.transform = `translateY(-${contentY}px)`
    }

    // Overlay intensity
    if (this.parallaxOverlay) {
      const overlayOpacity = 0.3 + scrollProgress * 0.3
      this.parallaxOverlay.style.background = `linear-gradient(
        135deg,
        rgba(0, 0, 0, ${overlayOpacity}) 0%,
        rgba(0, 0, 0, ${overlayOpacity * 0.5}) 50%,
        rgba(0, 0, 0, ${overlayOpacity * 1.2}) 100%
      )`
    }

    // Add scrolled class for CSS transitions
    if (scrollProgress > 0.1) {
      this.container.classList.add("scrolled")
    } else {
      this.container.classList.remove("scrolled")
    }
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new CollectionParallax()
})

// Also initialize if script loads after DOM
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new CollectionParallax()
  })
} else {
  new CollectionParallax()
}
